import { AxiosError } from 'axios';
import { POST_VERIFY_UNIQUE_LINK_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface VerifyUniqueLinkResponse {
  token: string;
  userType: string;
  examLevel: string;
  isWaiveLateFee?: boolean;
  isWaiveSubjectFee?: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: VerifyUniqueLinkResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostVerifyUniqueLink = ({ onSuccess, onError }: Input = {}) => {
  const postSendUniqueLink = async ({
    token,
    applicationType,
  }: {
    token: string;
    applicationType: string;
  }) => {
    const res = await axiosClient.post<VerifyUniqueLinkResponse>(POST_VERIFY_UNIQUE_LINK_URL, {
      token,
      applicationType,
    });

    return res.data;
  };

  return useCustomMutation(postSendUniqueLink, {
    onSuccess,
    onError,
  });
};
